import { format } from 'date-fns';
import { ICreateWorkerFormData } from 'forms/worker';

interface ICreateAccountBody {
    perspectiveId: number;
    companyId: number;
    person: {
        firstName: string;
        lastName: string;
        middleName: string;
        gender: string;
        phone: string;
        email: string;
        dateOfBirth: string;
        placeOfBirth: string;
        photo?: string;
        nextOfKin: {
            'nokRelationship': string;
            'nokFirstName': string;
            'nokLastName': string;
            'nokPhoneNumber': string;
            'nokEmail': string;
        },
        'drivingLicense': {
            'licenseClass': string;
            'expiry': string;
            'number': string;
            'state': string
        },
        'address': {
            'street': string;
            'town': string;
            'state': string;
            'postCode': string;
            'country': string;
        }
    }
}

export interface ICreateNewAccount {
    workerId?: string;
    onsiteToken?: string;
    errorCode?: string;
    message?: string;
}

export const createNewAccount = async (formData: ICreateWorkerFormData, token: string): Promise<ICreateNewAccount> => {
    const companyId = (window as any).ENV.REACT_APP_COMPANY_ID ? +(window as any).ENV.REACT_APP_COMPANY_ID : 138;
    const perspectiveId = (window as any).ENV.REACT_APP_PERSPECTIVE_ID ? +(window as any).ENV.REACT_APP_PERSPECTIVE_ID : 70119;

    const {dob, agreeToTerms, photo, confirmEmail, ...personInput} = formData;

    const workerObject = {
        perspectiveId,
        companyId,
        person: {
            gender: null,
            placeOfBirth: '',
            ...personInput,
            drivingLicense: {
                licenseClass: '',
                expiry: '',
                number: '',
                state: ''
            },
            dateOfBirth: dob ? format(dob, 'yyyy-MM-dd') : null,
        }
    } as ICreateAccountBody;

    const options = {
        method: 'POST',
        body: JSON.stringify(workerObject),
        headers: {
            'Content-Type': 'application/json'
        },
    } as RequestInit;

    return fetch(`/api/v1/worker?token=${token}`, options)
        .then(res => {
            return res.json();
        })
        .catch(err => {
            console.log('Error creating account', err);
        });
};
